import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import ColouredText from '../../components/ColouredText';

const PersonaPhase = ({ phaseData }) => {
    const [personaPhaseData, setPersonaPhaseData] = useState(null);

    useEffect(() => {
        if (phaseData !== undefined)
            setPersonaPhaseData(phaseData);
    }, [phaseData]);

    if (personaPhaseData === null) {
        return null;
    }

    console.log(personaPhaseData)

    return (<>
        <Row className={"pt-3"}>
            <h6>Phase {personaPhaseData.phase}</h6>

        </Row>
        <Row>
            <Col md={2}>
                <strong>Next Phase: </strong>
            </Col>
            <Col md={2}>
                {personaPhaseData.nextPhase}
            </Col>
        </Row>
        <Row>
            {personaPhaseData.data.map((data, dataIndex) =>
                <Row key={dataIndex}>
                    <span>{dataIndex + 1}. {data.prompt ? "Prompt " : "Entry "} = {data.text}</span>
                    <ColouredText ColouredText={data.text}/> 
                </Row>
            )}

        </Row>
    </>);
}

export default PersonaPhase;